import type { EventDTO } from '~entities/index'

export const mergeEvents = (
	first: EventDTO[] | undefined,
	second: EventDTO[] | undefined
): EventDTO[] => {
	const keys: (keyof EventDTO)[] = ['name', 'date']

	const map = new Map()

	const addEventToMap = (item: EventDTO) => {
		const id = keys.map((k) => {
			const value = item[k]

			if (k === 'name' && typeof value === 'string')
				return value.trim().toLowerCase()

			return value
		}).join('|')
		map.set(id, item)
	}

	first?.forEach(addEventToMap)
	second?.forEach(addEventToMap)

	return Array.from(map.values())
}
